class PostCards extends HTMLElement {
  constructor() {
    super();
    console.log("post-cards elements");
    const templateContent = document
      .querySelector("#image-cards-template")
      .content.cloneNode(true);
    const shadowRoot = this.attachShadow({ mode: "open" });
    shadowRoot.appendChild(templateContent);
  }
}
customElements.define("post-cards", PostCards);

const cardsWrapper = document.querySelector("#cards-wrapper");
if (cardsWrapper) {
  cardsWrapper.appendChild(document.createElement("post-cards"));
}
